import React, { useState } from "react";
import CustomInput from "../../common/CustomInput";
import StaffProfileDropdown from "../../common/StaffProfileDropdown";

const AddExperienceModal = ({ onClose, onAdd, hideResumeUpload = false }) => {
  const [formData, setFormData] = useState({
    club: "",
    country: "",
    position: "",
    startDate: "",
    endDate: "",
    resume: null,
  });

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const experienceData = {
      club: formData.club,
      country: formData.country,
      role: formData.position,
      from: formData.startDate,
      to: formData.endDate,
      resume: formData.resume,
    };

    onAdd(experienceData);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        resume: file,
      }));
    }
  };

  // eslint-disable-next-line global-require
  const { STAFF_ROLE_OPTIONS } = require("../../../constants/staffRoles");
  const positionOptions = STAFF_ROLE_OPTIONS;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl mx-4">
        {/* Header */}
        <div className="flex justify-between items-center border-b border-[#E6E6E6] pb-6 mb-6">
          <h2 className="text-[16px] font-bold text-[#3C3C3C]">
            ADD EXPERIENCE
          </h2>
          <div className="flex gap-2">
            <button
              onClick={onClose}
              className="px-4 py-2 border border-[#E6E6E6] bg-white text-[#1E1E1E] rounded-lg"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="px-4 py-2 bg-[#2283FF] text-white rounded-lg"
            >
              Save
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Club Name */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-bold text-[#3C3C3C] mb-2">
                CLUB NAME
              </label>
              <input
                type="text"
                value={formData.club}
                onChange={(e) => handleInputChange("club", e.target.value)}
                placeholder="Add title here"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-[#1A212FB2] text-[14px] placeholder:text-[14px] font-medium placeholder:font-medium placeholder:text-[#1A212F66]"
              />
            </div>

            <div>
              <label className="block text-xs font-bold text-[#3C3C3C] mb-2">
                POSITION
              </label>
              <StaffProfileDropdown
                value={formData.position}
                onChange={(value) => handleInputChange("position", value)}
                options={positionOptions}
                placeholder="Select Position"
              />
            </div>
          </div>
          {/* Position */}

          {/* Country, Start Month/Year, End Month/Year in same row */}
          <div className="grid grid-cols-3 gap-4">
            {/* Country */}
            <div>
              <label className="block text-xs font-bold text-[#3C3C3C] mb-2">
                COUNTRY
              </label>
              <input
                type="text"
                value={formData.country}
                onChange={(e) => handleInputChange("country", e.target.value)}
                placeholder="Add country here"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-[#1A212FB2] text-[14px] placeholder:text-[14px] font-medium placeholder:font-medium placeholder:text-[#1A212F66]"
              />
            </div>

            {/* Start Month/Year */}
            <div>
              <label className="block text-xs font-bold text-[#3C3C3C] mb-2">
                START MONTH/YEAR
              </label>
              <div className="relative">
                <input
                  type="month"
                  value={formData.startDate}
                  onChange={(e) =>
                    handleInputChange("startDate", e.target.value)
                  }
                  placeholder="MM/YYYY"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-[#1A212FB2] text-[14px] placeholder:text-[14px] font-medium placeholder:font-medium placeholder:text-[#1A212F66]"
                />
              </div>
            </div>

            {/* End Month/Year */}
            <div>
              <label className="block text-xs font-bold text-[#3C3C3C] mb-2">
                END MONTH/YEAR
              </label>
              <div className="relative">
                <input
                  type="month"
                  value={formData.endDate}
                  onChange={(e) => handleInputChange("endDate", e.target.value)}
                  placeholder="MM/YYYY"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-[#1A212FB2] text-[14px] placeholder:text-[14px] font-medium placeholder:font-medium placeholder:text-[#1A212F66]"
                />
              </div>
            </div>
          </div>

          {/* Upload Resume - Hidden for coach profile */}
          {!hideResumeUpload && (
            <div>
              <button
                type="button"
                onClick={() =>
                  document.getElementById("experience-resume").click()
                }
                className="w-fit px-4 py-2 border border-[#E6E6E6] bg-white text-[#1E1E1E] rounded-lg flex items-center gap-2"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 9V11.6667C13 12.0203 12.8595 12.3594 12.6095 12.6095C12.3594 12.8595 12.0203 13 11.6667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V9M10.3333 4.33333L7 1M7 1L3.66667 4.33333M7 1V9"
                    stroke="#2C2C2C"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Upload resume
              </button>
              <input
                id="experience-resume"
                type="file"
                onChange={handleFileUpload}
                className="hidden"
                accept=".pdf,.doc,.docx"
              />
              {formData.resume && (
                <p className="text-sm text-gray-600 mt-2">
                  Selected: {formData.resume.name}
                </p>
              )}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default AddExperienceModal;
